/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmailStyleTemplate } from '../models/EmailStyleTemplate';
import type { EmailStyleTemplateDto } from '../models/EmailStyleTemplateDto';
import type { EmailTemplate } from '../models/EmailTemplate';
import type { EmailTemplateDto } from '../models/EmailTemplateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EmailTemplatesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all email templates from the DB.
     * @param orgGuid
     * @param workflowDefinitionGuid
     * @param includeGlobalTemplates
     * @returns EmailTemplateDto OK
     * @throws ApiError
     */
    public getAllEmailTemplates(
        orgGuid?: string,
        workflowDefinitionGuid?: string,
        includeGlobalTemplates: boolean = false,
    ): CancelablePromise<Array<EmailTemplateDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/EmailTemplates/GetAllEmailTemplates',
            query: {
                'orgGuid': orgGuid,
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'includeGlobalTemplates': includeGlobalTemplates,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single email template by its guid.
     * @param guid
     * @param orgGuid
     * @returns EmailTemplate OK
     * @throws ApiError
     */
    public getEmailTemplate(
        guid: string,
        orgGuid: string,
    ): CancelablePromise<EmailTemplate> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/EmailTemplates/{guid}/{orgGuid}/GetEmailTemplate',
            path: {
                'guid': guid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new email template.
     * @param emailTemplateName
     * @param orgGuid
     * @param workflowDefinitionGuid
     * @returns EmailTemplate OK
     * @throws ApiError
     */
    public createEmailTemplate(
        emailTemplateName?: string,
        orgGuid?: string,
        workflowDefinitionGuid?: string,
    ): CancelablePromise<EmailTemplate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/EmailTemplates/CreateEmailTemplate',
            query: {
                'emailTemplateName': emailTemplateName,
                'orgGuid': orgGuid,
                'workflowDefinitionGuid': workflowDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update an email template.
     * @param emailTemplateGuid The template GUID.
     * @param requestBody The updated email template
     * @returns EmailTemplateDto OK
     * @throws ApiError
     */
    public updateEmailTemplate(
        emailTemplateGuid: string,
        requestBody?: EmailTemplate,
    ): CancelablePromise<EmailTemplateDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/EmailTemplates/{emailTemplateGuid}/UpdateEmailTemplate',
            path: {
                'emailTemplateGuid': emailTemplateGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an existing email template.
     * @param emailTemplateGuid The template GUID.
     * @param orgGuid The organization's GUID.
     * @returns EmailTemplate OK
     * @throws ApiError
     */
    public deleteEmailTemplate(
        emailTemplateGuid: string,
        orgGuid: string,
    ): CancelablePromise<EmailTemplate> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/EmailTemplates/{orgGuid}/{emailTemplateGuid}/DeleteEmailTemplate',
            path: {
                'emailTemplateGuid': emailTemplateGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all email style templates from the DB.
     * @param orgGuid
     * @returns EmailStyleTemplateDto OK
     * @throws ApiError
     */
    public getAllEmailStyleTemplates(
        orgGuid: string,
    ): CancelablePromise<Array<EmailStyleTemplateDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/EmailTemplates/{orgGuid}/GetAllEmailStyleTemplates',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single email style template by its guid.
     * @param guid
     * @param orgGuid
     * @returns EmailStyleTemplate OK
     * @throws ApiError
     */
    public getEmailStyleTemplate(
        guid: string,
        orgGuid: string,
    ): CancelablePromise<EmailStyleTemplate> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/EmailTemplates/{guid}/{orgGuid}/GetEmailStyleTemplate',
            path: {
                'guid': guid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new email template.
     * @param emailStyleTemplateName
     * @param orgGuid
     * @returns EmailStyleTemplate OK
     * @throws ApiError
     */
    public createEmailStyleTemplate(
        emailStyleTemplateName?: string,
        orgGuid?: string,
    ): CancelablePromise<EmailStyleTemplate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/EmailTemplates/CreateEmailStyleTemplate',
            query: {
                'emailStyleTemplateName': emailStyleTemplateName,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update an email style template.
     * @param emailStyleTemplateGuid The template GUID.
     * @param requestBody The updated email template
     * @returns EmailStyleTemplateDto OK
     * @throws ApiError
     */
    public updateEmailStyleTemplate(
        emailStyleTemplateGuid: string,
        requestBody?: EmailStyleTemplate,
    ): CancelablePromise<EmailStyleTemplateDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/EmailTemplates/{emailStyleTemplateGuid}/UpdateEmailStyleTemplate',
            path: {
                'emailStyleTemplateGuid': emailStyleTemplateGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an existing email style template.
     * @param emailStyleTemplateGuid The template GUID.
     * @param orgGuid The organization's GUID.
     * @returns EmailStyleTemplate OK
     * @throws ApiError
     */
    public deleteEmailStyleTemplate(
        emailStyleTemplateGuid: string,
        orgGuid: string,
    ): CancelablePromise<EmailStyleTemplate> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/EmailTemplates/{orgGuid}/{emailStyleTemplateGuid}/DeleteEmailStyleTemplate',
            path: {
                'emailStyleTemplateGuid': emailStyleTemplateGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
